module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "persistent": "",
      "max-width": "600px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [(_vm.influencer || _vm.multiple) ? _c('v-card', [_c('v-toolbar', {
    attrs: {
      "color": "elevation-2"
    }
  }, [(!_vm.multiple) ? _c('h2', {
    staticClass: "headline"
  }, [_vm._v("@" + _vm._s(_vm.influencer.userHandle) + " ")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.multiple) ? _c('h2', {
    staticClass: "headline"
  }, [_vm._v("Update Deliverables")]) : _c('h2', {
    staticClass: "headline"
  }, [_vm._v("Deliverables")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (!_vm.multiple) ? _c('h3', [_vm._v(_vm._s(_vm.influencer.payoutAmount) + "$")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [(!_vm.multiple) ? _c('v-list', [_c('v-list-item', {
    staticClass: "mb--10"
  }, [_c('v-list-item-content', {
    staticClass: "pt-2"
  }), _vm._v(" "), _c('v-list-item-action', [_c('p', {
    staticClass: "body-1 mb-0"
  }, [_vm._v("\n                " + _vm._s('$' + _vm.pairedInfluencer.multipliedPrice1 + ' - $' + _vm.pairedInfluencer.multipliedPrice2) + "\n                "), _c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("mdi-account-cog")])], 1)])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-list', [_c('v-list-item', {
    staticClass: "mb--10"
  }, [_c('v-list-item-content', {
    staticClass: "pt-2"
  }, [_c('v-list-item-title', {
    staticClass: "subtitle-1"
  }, [_vm._v("\n                TikTok Posts\n              ")])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-text-field', {
    attrs: {
      "type": "number",
      "solo": "",
      "min": "0",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.no_of_tiktok_posts),
      callback: function($$v) {
        _vm.no_of_tiktok_posts = _vm._n($$v)
      },
      expression: "no_of_tiktok_posts"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hint--text"
  }, [_vm._v("in number of TikTok Posts")])], 1)], 1)], 1), _vm._v(" "), _c('v-list', [_c('v-list-item', {
    staticClass: "mb--10"
  }, [_c('v-list-item-content', {
    staticClass: "pt-2"
  }, [_c('v-list-item-title', {
    staticClass: "subtitle-1"
  }, [_vm._v("\n                XHS Posts\n              ")])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-text-field', {
    attrs: {
      "type": "number",
      "solo": "",
      "min": "0",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.no_of_xhs_posts),
      callback: function($$v) {
        _vm.no_of_xhs_posts = _vm._n($$v)
      },
      expression: "no_of_xhs_posts"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hint--text"
  }, [_vm._v("in number of Xiaohongshu Posts")])], 1)], 1)], 1), _vm._v(" "), _c('v-list', [_c('v-list-item', {
    staticClass: "mb--10"
  }, [_c('v-list-item-content', {
    staticClass: "pt-2"
  }, [_c('v-list-item-title', {
    staticClass: "subtitle-1"
  }, [_vm._v("\n                FB Posts\n              ")])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-text-field', {
    attrs: {
      "type": "number",
      "solo": "",
      "min": "0",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.no_of_fb_posts),
      callback: function($$v) {
        _vm.no_of_fb_posts = _vm._n($$v)
      },
      expression: "no_of_fb_posts"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hint--text"
  }, [_vm._v("in number of Facebook Posts")])], 1)], 1)], 1), _vm._v(" "), _c('v-list', [_c('v-list-item', {
    staticClass: "mb--10"
  }, [_c('v-list-item-content', {
    staticClass: "pt-2"
  }, [_c('v-list-item-title', {
    staticClass: "subtitle-1"
  }, [_vm._v("\n                IG Posts\n              ")])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-text-field', {
    attrs: {
      "type": "number",
      "solo": "",
      "dense": "",
      "min": "0",
      "hide-details": ""
    },
    model: {
      value: (_vm.no_of_posts),
      callback: function($$v) {
        _vm.no_of_posts = _vm._n($$v)
      },
      expression: "no_of_posts"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hint--text"
  }, [_vm._v("in number of IG Posts")])], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "mb--10"
  }, [_c('v-list-item-content', {
    staticClass: "pt-2"
  }, [_c('v-list-item-title', {
    staticClass: "subtitle-1"
  }, [_vm._v("\n                IG Carousels\n              ")])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-text-field', {
    attrs: {
      "type": "number",
      "solo": "",
      "dense": "",
      "min": "0",
      "hide-details": ""
    },
    model: {
      value: (_vm.no_of_carousels),
      callback: function($$v) {
        _vm.no_of_carousels = _vm._n($$v)
      },
      expression: "no_of_carousels"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hint--text"
  }, [_vm._v("in number of IG Carousels")])], 1)], 1), _vm._v(" "), (_vm.no_of_video) ? _c('v-list-item', {
    staticClass: "mb--10"
  }, [_c('v-list-item-content', {
    staticClass: "pt-2"
  }, [_c('v-list-item-title', {
    staticClass: "subtitle-1"
  }, [_vm._v("\n                IG Videos\n              ")])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-text-field', {
    attrs: {
      "type": "number",
      "solo": "",
      "dense": "",
      "min": "0",
      "hide-details": ""
    },
    model: {
      value: (_vm.no_of_video),
      callback: function($$v) {
        _vm.no_of_video = _vm._n($$v)
      },
      expression: "no_of_video"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hint--text"
  }, [_vm._v("in number of Videos")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-list-item', {
    staticClass: "mb--10"
  }, [_c('v-list-item-content', {
    staticClass: "pt-2"
  }, [_c('v-list-item-title', {
    staticClass: "subtitle-1"
  }, [_vm._v("\n                IG Stories\n              ")])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-text-field', {
    attrs: {
      "type": "number",
      "solo": "",
      "dense": "",
      "min": "0",
      "hide-details": ""
    },
    model: {
      value: (_vm.no_of_stories),
      callback: function($$v) {
        _vm.no_of_stories = _vm._n($$v)
      },
      expression: "no_of_stories"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hint--text"
  }, [_vm._v("in number of IG Stories")])], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "mb--10"
  }, [_c('v-list-item-content', {
    staticClass: "pt-2"
  }, [_c('v-list-item-title', {
    staticClass: "subtitle-1"
  }, [_vm._v("\n                IG Reels\n              ")])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-text-field', {
    attrs: {
      "type": "number",
      "solo": "",
      "dense": "",
      "min": "0",
      "hide-details": ""
    },
    model: {
      value: (_vm.no_of_reels),
      callback: function($$v) {
        _vm.no_of_reels = _vm._n($$v)
      },
      expression: "no_of_reels"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hint--text"
  }, [_vm._v("in number of IG Reels")])], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "mb--10"
  }, [_c('v-list-item-content', {
    staticClass: "pt-2"
  }, [_c('v-list-item-title', {
    staticClass: "subtitle-1"
  }, [_vm._v("\n                LinkedIn Posts\n              ")])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-text-field', {
    attrs: {
      "type": "number",
      "solo": "",
      "dense": "",
      "min": "0",
      "hide-details": ""
    },
    model: {
      value: (_vm.no_of_li_posts),
      callback: function($$v) {
        _vm.no_of_li_posts = _vm._n($$v)
      },
      expression: "no_of_li_posts"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hint--text"
  }, [_vm._v("in number of LinkedIn Posts")])], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "mb--10"
  }, [_c('v-list-item-content', {
    staticClass: "pt-2"
  }, [_c('v-list-item-title', {
    staticClass: "subtitle-1"
  }, [_vm._v("X (Twitter) Posts")])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-text-field', {
    attrs: {
      "type": "number",
      "solo": "",
      "dense": "",
      "min": "0",
      "hide-details": ""
    },
    model: {
      value: (_vm.no_of_x_posts),
      callback: function($$v) {
        _vm.no_of_x_posts = _vm._n($$v)
      },
      expression: "no_of_x_posts"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hint--text"
  }, [_vm._v("in number of X (Twitter) Posts")])], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    staticClass: "pt-0"
  }, [_c('v-list-item', {
    staticClass: "mb--10"
  }, [_c('v-list-item-content', {
    staticClass: "pt-2"
  }, [_c('v-list-item-title', {
    staticClass: "subtitle-1"
  }, [_vm._v("\n                Youtube\n              ")])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-text-field', {
    attrs: {
      "type": "number",
      "solo": "",
      "dense": "",
      "min": "0",
      "hide-details": ""
    },
    model: {
      value: (_vm.youtube),
      callback: function($$v) {
        _vm.youtube = _vm._n($$v)
      },
      expression: "youtube"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hint--text"
  }, [_vm._v("in number of Youtube videos")])], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "mb--10"
  }, [_c('v-list-item-content', {
    staticClass: "pt-2"
  }, [_c('v-list-item-title', {
    staticClass: "subtitle-1"
  }, [_vm._v("\n                Loading/Whitelisting\n              ")])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-text-field', {
    attrs: {
      "type": "number",
      "min": "0",
      "hide-details": "",
      "solo": "",
      "dense": ""
    },
    model: {
      value: (_vm.loading_whitelisting),
      callback: function($$v) {
        _vm.loading_whitelisting = $$v
      },
      expression: "loading_whitelisting"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hint--text"
  }, [_vm._v("in months")])], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "mb--10"
  }, [_c('v-list-item-content', {
    staticClass: "pt-2"
  }, [_c('v-list-item-title', {
    staticClass: "subtitle-1"
  }, [_vm._v("\n                Exclusivity\n              ")])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-text-field', {
    attrs: {
      "type": "number",
      "min": "0",
      "solo": "",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.exclusivity),
      callback: function($$v) {
        _vm.exclusivity = $$v
      },
      expression: "exclusivity"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hint--text"
  }, [_vm._v("in months")])], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "mb--10"
  }, [_c('v-list-item-content', {
    staticClass: "pt-2"
  }, [_c('v-list-item-title', {
    staticClass: "subtitle-1"
  }, [_vm._v("\n                Physical Attendance\n              ")])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-text-field', {
    attrs: {
      "type": "number",
      "solo": "",
      "dense": "",
      "min": "0",
      "hide-details": ""
    },
    model: {
      value: (_vm.physical_attendance),
      callback: function($$v) {
        _vm.physical_attendance = _vm._n($$v)
      },
      expression: "physical_attendance"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hint--text"
  }, [_vm._v("in hours")])], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "mb--10"
  }, [_c('v-list-item-content', {
    staticClass: "pt-2"
  }, [_c('v-list-item-title', {
    staticClass: "subtitle-1"
  }, [_vm._v("\n                Online Attendance\n              ")])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-text-field', {
    attrs: {
      "type": "number",
      "solo": "",
      "dense": "",
      "min": "0",
      "hide-details": ""
    },
    model: {
      value: (_vm.online_attendance),
      callback: function($$v) {
        _vm.online_attendance = _vm._n($$v)
      },
      expression: "online_attendance"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hint--text"
  }, [_vm._v("in hours")])], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    staticClass: "pt-0"
  }, _vm._l((_vm.customDeliverables), function(custom, index) {
    return _c('v-list-item', {
      key: index,
      staticClass: "mb--10"
    }, [_c('v-list-item-content', {
      staticClass: "pt-0",
      staticStyle: {
        "margin-top": "-10px"
      }
    }, [_c('v-list-item-title', {
      staticClass: "subtitle-2"
    }, [_vm._v("\n                Custom\n              ")]), _vm._v(" "), _c('v-text-field', {
      attrs: {
        "dense": "",
        "hide-details": ""
      },
      model: {
        value: (custom.label),
        callback: function($$v) {
          _vm.$set(custom, "label", $$v)
        },
        expression: "custom.label"
      }
    })], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-text-field', {
      staticStyle: {
        "max-width": "200px"
      },
      attrs: {
        "type": "number",
        "solo": "",
        "append-outer-icon": "mdi-delete-forever"
      },
      on: {
        "click:append-outer": function($event) {
          return _vm.deleteCustom(index)
        }
      },
      model: {
        value: (custom.value),
        callback: function($$v) {
          _vm.$set(custom, "value", _vm._n($$v))
        },
        expression: "custom.value"
      }
    })], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    staticClass: "secondary",
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Save")])], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4be6504e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/PairingInfluencer/PriceMultiplierModal.vue
// module id = 2112
// module chunks = 0